import React, { useState } from 'react';
import './Testimonials.css';

const testimonialsData = [
  {
    id: 1,
    name: 'Rajesh Kumar',
    position: 'CEO',
    company: 'Tech Innovations Ltd',
    image: 'R',
    text: 'DT Consultancy transformed our business with their exceptional web development and cloud migration services. Their team is professional, responsive, and truly understands business needs. The ROI we achieved exceeded all expectations.',
    rating: 5,
    color: '#6366f1'
  },
  {
    id: 2,
    name: 'Priya Sharma',
    position: 'Marketing Director',
    company: 'StartUp Hub',
    image: 'P',
    text: 'The digital marketing and lead management solutions provided by DT Consultancy have significantly improved our conversion rates. Their strategic approach and attention to detail are unmatched. Highly recommended!',
    rating: 5,
    color: '#8b5cf6'
  },
  {
    id: 3,
    name: 'Amit Patel',
    position: 'CTO',
    company: 'DataFlow Systems',
    image: 'A',
    text: 'Their expertise in data engineering and AI solutions is outstanding. The custom AI application they developed for us exceeded our expectations in every way. The team\'s technical knowledge is truly impressive.',
    rating: 5,
    color: '#ec4899'
  },
  {
    id: 4,
    name: 'Sneha Reddy',
    position: 'Operations Manager',
    company: 'BuildTech',
    image: 'S',
    text: 'The CAD designing services and technical expertise of DT Consultancy helped us streamline our engineering processes. Excellent work quality and timely delivery. They are now our go-to technology partner.',
    rating: 5,
    color: '#10b981'
  }
];

const Testimonials = () => {
  const [activeTestimonial, setActiveTestimonial] = useState(0);

  return (
    <section className="testimonials" id="testimonials">
      <div className="container">
        <h2 className="section-title">Client Success Stories</h2>
        <p className="section-subtitle">
          Discover how we've helped businesses achieve their digital transformation goals
        </p>
        
        <div className="testimonials-showcase">
          <div className="featured-testimonial">
            <div className="testimonial-quote-large">"</div>
            <p className="testimonial-text-large">
              {testimonialsData[activeTestimonial].text}
            </p>
            
            <div className="testimonial-author-featured">
              <div 
                className="author-avatar-large"
                style={{background: testimonialsData[activeTestimonial].color}}
              >
                {testimonialsData[activeTestimonial].image}
              </div>
              <div className="author-details">
                <h4>{testimonialsData[activeTestimonial].name}</h4>
                <p>{testimonialsData[activeTestimonial].position}</p>
                <p className="company-name">{testimonialsData[activeTestimonial].company}</p>
              </div>
              <div className="rating-large">
                {[...Array(testimonialsData[activeTestimonial].rating)].map((_, i) => (
                  <span key={i} className="star-large">⭐</span>
                ))}
              </div>
            </div>
          </div>

          <div className="testimonials-sidebar">
            {testimonialsData.map((testimonial, index) => (
              <div
                key={testimonial.id}
                className={`testimonial-mini ${activeTestimonial === index ? 'active' : ''}`}
                onClick={() => setActiveTestimonial(index)}
              >
                <div 
                  className="mini-avatar"
                  style={{background: testimonial.color}}
                >
                  {testimonial.image}
                </div>
                <div className="mini-content">
                  <h5>{testimonial.name}</h5>
                  <p>{testimonial.company}</p>
                </div>
                <div className="mini-indicator"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="testimonials-grid-mobile">
          {testimonialsData.map((testimonial) => (
            <div className="testimonial-card-mobile" key={testimonial.id}>
              <div className="quote-icon">"</div>
              <div className="rating">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <span key={i} className="star">⭐</span>
                ))}
              </div>
              <p className="testimonial-text">{testimonial.text}</p>
              <div className="testimonial-author">
                <div 
                  className="author-avatar"
                  style={{background: testimonial.color}}
                >
                  {testimonial.image}
                </div>
                <div className="author-info">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.position}</p>
                  <p className="company">{testimonial.company}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
